module.exports = __webpack_public_path__ + "img/Mask Group 3@2x.png";